module.exports = __webpack_public_path__ + "img/819-9cee29.png";